<template>
<div>

  <div class="" style="width: 1024px; margin: auto;">


    <div class="" >
    <circle4 v-if="loading"></circle4>

<!-- <button type="button" @click="exportDocx">export doc</button> -->
    <!-- <a :href="'http://localhost:44534/export/pdf/de/2018/' + tokwt">pdf</a> -->

    <div class="spacer sm"></div>
      <!-- <p v-for="ratioquest in ratioquests">{{ratioquest.cat}}</p> -->

      <!-- <a v-on:click="saveContent" style="position: absolute; top: 12px; right: 12px;"><span class="fa fa-flash"></span></a> -->

      <!-- <vue-editor id="editor1" v-model="content[1]"></vue-editor> -->
      <div v-html="content[1]"></div>

      <h2 v-if="benchlang === 'de'">1. FÜHRUNG</h2>
      <h2 v-if="benchlang === 'it'">1. DIRIGENZA</h2>

      <h5 v-if="benchlang === 'de'">Verhältnis Brutto- / Nettostunden Mitarbeiter in Prozent (Anteil Ist-Stunden auf Sollstunden der Mitarbeiter)</h5>
      <h5 v-if="benchlang === 'it'">Ore prestate dai collaboratori: lordo/netto (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[1].total / klein[1].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[1].total / mittel[1].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[1].total / gross[1].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[1].total / klein[1].arr.length)+(mittel[1].total / mittel[1].arr.length)+(gross[1].total / gross[1].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Verhältnis Brutto- / Nettostunden Mitarbeiter in Prozent (Anteil Ist-Stunden auf Sollstunden der Mitarbeiter)', fontColor: '#000', fontSize: '18', padding: 40 }}" width="2048" height="800"></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[1].total / klein[1].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[1].total / mittel[1].arr.length]
                      },
                      {
                        label: 'Strutture Grandi',
                        backgroundColor: '#77933C',
                        data: [gross[1].total / gross[1].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[1].total / klein[1].arr.length)+(mittel[1].total / mittel[1].arr.length)+(gross[1].total / gross[1].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Ore prestate dai collaboratori: lordo/netto (media)', padding: 40 }}" ></stats>

                  <button type="button" @click="downcanvas">download</button>
                  <a download='myImage.jpg' href='' @click='downcanvas(this)'>Download to myImage.jpg</a>

      <div v-html="content[2]"></div>

      <h2 v-if="benchlang === 'de'">2. POLITIK UND STRATEGIE</h2>
      <h2 v-if="benchlang === 'it'">2. POLITICA E STRATEGIA</h2>

      <h5 v-if="benchlang === 'de'">Auslastung in den RQA-Heimen (Mittelwerte in Prozent)</h5>
      <h5 v-if="benchlang === 'it'">Copertura posti letto nelle residenze RQA (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: ['Bettenauslastung Daueraufnahme', 'Bettenauslastung Kurzzeitpflege', 'Auslastung Tagespflege', 'Auslastung des Tagespflegeheims'],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[2].total / klein[2].arr.length, klein[3].total / klein[3].arr.length, klein[4].total / klein[4].arr.length ]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[2].total / mittel[2].arr.length, mittel[3].total / mittel[3].arr.length, mittel[4].total / mittel[4].arr.length ]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[2].total / gross[2].arr.length, gross[3].total / gross[3].arr.length, gross[4].total / gross[4].arr.length ]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[2].total / klein[2].arr.length)+(mittel[2].total / mittel[2].arr.length)+(gross[2].total / gross[2].arr.length))/3, ((klein[3].total / klein[3].arr.length)+(mittel[3].total / mittel[3].arr.length)+(gross[3].total / gross[3].arr.length))/3, ((klein[4].total / klein[4].arr.length)+(mittel[4].total / mittel[4].arr.length)+(gross[4].total / gross[4].arr.length))/3, overall[5].total / overall[5].arr.length]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return '' } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, max: 120 } }] }, title: { display: false, text: 'Auslastung in den RQA-Heimen (Mittelwerte)', padding: 40
        }}" ></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: ['Ricovero permanente', 'Ricovero temporaneo', 'Assistenza diurna', 'Assistenza diurna'],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[2].total / klein[2].arr.length, klein[3].total / klein[3].arr.length, klein[4].total / klein[4].arr.length ]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[2].total / mittel[2].arr.length, mittel[3].total / mittel[3].arr.length, mittel[4].total / mittel[4].arr.length ]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[2].total / gross[2].arr.length, gross[3].total / gross[3].arr.length, gross[4].total / gross[4].arr.length ]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[2].total / klein[2].arr.length)+(mittel[2].total / mittel[2].arr.length)+(gross[2].total / gross[2].arr.length))/3, ((klein[3].total / klein[3].arr.length)+(mittel[3].total / mittel[3].arr.length)+(gross[3].total / gross[3].arr.length))/3, ((klein[4].total / klein[4].arr.length)+(mittel[4].total / mittel[4].arr.length)+(gross[4].total / gross[4].arr.length))/3, overall[5].total / overall[5].arr.length]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value) {if(isNaN(value)){return '' } return value.toFixed(2) }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true, max: 120 } }] }, title: { display: false, text: 'Auslastung in den RQA-Heimen (Mittelwerte)', padding: 40
        }}" ></stats>

        <div v-html="content[3]"></div>

        <h2 v-if="benchlang === 'de'">3. MITARBEITER</h2>
        <h2 v-if="benchlang === 'it'">3. COLLABORATORI</h2>

        <h5 v-if="benchlang === 'de'">Mitarbeiter in Teilzeit- / Vollzeitarbeitsverhältnis (Mittelwerte in Prozent und Anzahl)</h5>
        <h5 v-if="benchlang === 'it'">Collaboratori con rapporto di lavoro a tempo parziale / tempo pieno (media)</h5>

        <!-- <div><span class="legend green">Vollzeit</span><span class="legend yellow">Teilzeit</span></div> -->

      <div class="grid" style="grid-template-columns: 1fr 1fr 1fr;">
      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(klein[6].totval / klein[6].val.length), (klein[7].totval / klein[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: false, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Kleine Strukturen'}}" width="341px" height="341px"></pie>

      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(mittel[6].totval / mittel[6].val.length), (mittel[7].totval / mittel[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: false, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return Math.round(value * 100) / 100 + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Mittlere Strukturen'}}" width="341px" height="341px"></pie>

        <pie v-if="benchlang === 'de'" :chart-data="{
      labels: [
      'Teilzeit', 'Vollzeit'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)],
          cal: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          cal: [(gross[6].totval / gross[6].val.length), (gross[7].totval / gross[7].val.length)],
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: false, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex] + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Grosse Strukturen'}}" width="341px" height="341px"></pie>

       <pie v-if="benchlang === 'it'" :chart-data="{
      labels: [
      'Part-Time', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(klein[6].totval / klein[6].val.length), (klein[7].totval / klein[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture piccole'}}" width="341px" height="341px"></pie>

      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: [
      'Part-Time', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(mittel[6].total / mittel[6].arr.length), (mittel[7].total / mittel[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          data: [(mittel[6].totval / mittel[6].val.length), (mittel[7].totval / mittel[7].val.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return Math.round(value * 100) / 100 + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture medie'}}" width="341px" height="341px"></pie>

        <pie v-if="benchlang === 'it'" :chart-data="{
      labels: [
      'Part-Time', 'Tempo pieno'
      ],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: '%',
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)],
          cal: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)]
        },
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          labels: 'MA',
          cal: [(gross[6].totval / gross[6].val.length), (gross[7].totval / gross[7].val.length)],
          data: [(gross[6].total / gross[6].arr.length), (gross[7].total / gross[7].arr.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: true, position: 'bottom', reverse: true}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, formatter: function(value, context) {
    return context.chart.data.datasets[context.datasetIndex].cal[context.dataIndex] + ' ' + context.chart.data.datasets[context.datasetIndex].labels}}}, title: { display: true, position: 'top', text: 'Strutture grandi'}}" width="341px" height="341px"></pie>

        </div>

         <!-- <div class="w12">
          <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[6].total / klein[6].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[6].total / mittel[6].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[6].total / gross[6].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[6].total / klein[6].arr.length)+(mittel[6].total / mittel[6].arr.length)+(gross[6].total / gross[6].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }}"></stats>
        </div> -->

<!-- 
        <div class="grid" style="grid-template-columns: 1fr 2fr;">
      <div class="w4"><pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['Mitarbeit in Teilzeitarbeitsverhältnis (Anteil in % und Anzahl) - Stichtag: 31.12.', 'Mitarbeiter in Vollzeitarbeitsverhältnis (Anteil in % und Anzahl) - Stichtag: 31.12.'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#9BBB59'
          ],
          data: [(klein[6].total / klein[6].arr.length), (klein[7].total / klein[7].arr.length)]
        }
      ]
    }" :options="{responsive: false, maintainAspectRatio: true, legend: { display: false, position: 'top'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }}}, title: { display: false, text: 'Mitarbeit in Teilzeit- / Vollzeitarbeitsverhältnis (Mittelwerte)'
        }}" ></pie></div>

        <div class="w8">
          <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[6].total / klein[6].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[6].total / mittel[6].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[6].total / gross[6].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[6].total / klein[6].arr.length)+(mittel[6].total / mittel[6].arr.length)+(gross[6].total / gross[6].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }}"></stats>
        </div>

        </div> -->

        <div v-html="content[4]"></div>

      <h5 v-if="benchlang === 'de'">Bereich Pflege/Betreuung/REHA: Mitarbeiter Altersstufen (Mittelwerte in Prozent)</h5>
      <h5 v-if="benchlang === 'it'">Settore cura/assistenza/riabilitazione: fasce d’età dei collaboratori (media)</h5>

      <div class="grid" style="grid-template-columns: 1fr 1fr;">

      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[8].total / klein[8].arr.length), (klein[9].total / klein[9].arr.length), (klein[10].total / klein[10].arr.length), (klein[11].total / klein[11].arr.length), (klein[12].total / klein[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Kleine Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[8].total / mittel[8].arr.length), (mittel[9].total / mittel[9].arr.length), (mittel[10].total / mittel[10].arr.length), (mittel[11].total / mittel[11].arr.length), (mittel[12].total / mittel[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Mittlere Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[8].total / gross[8].arr.length), (gross[9].total / gross[9].arr.length), (gross[10].total / gross[10].arr.length), (gross[11].total / gross[11].arr.length), (gross[12].total / gross[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Grosse Strukturen'
        }}"></pie>


        <div class="grid" v-if="benchlang === 'de'" style="align-content: center; justify-content: center;">
          <span class="legend yellow">bis 30 Jahre alt</span>
          <span class="legend orange">31 - 40 Jahre alt</span>
          <span class="legend green">41 - 50 Jahre alt</span>
          <span class="legend greendark">51 - 60 Jahre alt</span>
          <span class="legend blue">über 61 Jahre alt</span>
        </div>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[8].total / klein[8].arr.length), (klein[9].total / klein[9].arr.length), (klein[10].total / klein[10].arr.length), (klein[11].total / klein[11].arr.length), (klein[12].total / klein[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture piccole'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[8].total / mittel[8].arr.length), (mittel[9].total / mittel[9].arr.length), (mittel[10].total / mittel[10].arr.length), (mittel[11].total / mittel[11].arr.length), (mittel[12].total / mittel[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture medie'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[8].total / gross[8].arr.length), (gross[9].total / gross[9].arr.length), (gross[10].total / gross[10].arr.length), (gross[11].total / gross[11].arr.length), (gross[12].total / gross[12].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture grandi'
        }}"></pie>


        <div v-if="benchlang === 'it'" class="grid" style="align-content: center; justify-content: center;">
          <span class="legend yellow">fino 30 anni</span>
          <span class="legend orange">31 - 40 anni</span>
          <span class="legend green">41 - 50 anni</span>
          <span class="legend greendark">51 - 60 anni</span>
          <span class="legend blue">oltre 61 anni</span>
        </div>

        </div>

        <div v-html="content[5]"></div>

      <h5 v-if="benchlang === 'de'">Nicht-Betreuungsbereich: Mitarbeiter Altersstufen (Mittelwerte in Prozent)</h5>
      <h5 v-if="benchlang === 'it'">Settore non-assistenziale: fasce d´etá dei collaboratori (media in %)</h5>

      <div class="grid" style="grid-template-columns: 1fr 1fr;">

      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[13].total / klein[13].arr.length), (klein[14].total / klein[14].arr.length), (klein[15].total / klein[15].arr.length), (klein[16].total / klein[16].arr.length), (klein[17].total / klein[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', align: 'center', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Kleine Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[13].total / mittel[13].arr.length), (mittel[14].total / mittel[14].arr.length), (mittel[15].total / mittel[15].arr.length), (mittel[16].total / mittel[16].arr.length), (mittel[17].total / mittel[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Mittlere Strukturen'
        }}"></pie>


      <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['bis 30 Jahre alt', '31-40 Jahre alt', '41-50 Jahre alt', '51-60 Jahre alt', 'über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[13].total / gross[13].arr.length), (gross[14].total / gross[14].arr.length), (gross[15].total / gross[15].arr.length), (gross[16].total / gross[16].arr.length), (gross[17].total / gross[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Grosse Strukturen'
        }}"></pie>


        <div class="grid" v-if="benchlang === 'de'" style="align-content: center; justify-content: center;">
          <span class="legend yellow">bis 30 Jahre alt</span>
          <span class="legend orange">31 - 40 Jahre alt</span>
          <span class="legend green">41 - 50 Jahre alt</span>
          <span class="legend greendark">51 - 60 Jahre alt</span>
          <span class="legend blue">über 61 Jahre alt</span>
        </div>


        <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(klein[13].total / klein[13].arr.length), (klein[14].total / klein[14].arr.length), (klein[15].total / klein[15].arr.length), (klein[16].total / klein[16].arr.length), (klein[17].total / klein[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', align: 'center', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture piccole'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(mittel[13].total / mittel[13].arr.length), (mittel[14].total / mittel[14].arr.length), (mittel[15].total / mittel[15].arr.length), (mittel[16].total / mittel[16].arr.length), (mittel[17].total / mittel[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'right'}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture medie'
        }}"></pie>


      <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['fino 30 anni', '31-40 anni', '41-50 anni', '51-60 anni', 'oltre 61 anni'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          labels: '',
          data: [(gross[13].total / gross[13].arr.length), (gross[14].total / gross[14].arr.length), (gross[15].total / gross[15].arr.length), (gross[16].total / gross[16].arr.length), (gross[17].total / gross[17].arr.length)]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: false, position: 'bottom', fullWidth: true}, plugins: { datalabels: { color: '#000', formatter: function(value, context) {
    return value.toFixed(2) + ' ' + context.chart.data.datasets[context.datasetIndex].labels}, font: { weight: 'bold' }}}, title: { display: true, text: 'Strutture grandi'
        }}"></pie>


        <div v-if="benchlang === 'it'" class="grid" style="align-content: center; justify-content: center;">
          <span class="legend yellow">fino 30 anni</span>
          <span class="legend orange">31 - 40 anni</span>
          <span class="legend green">41 - 50 anni</span>
          <span class="legend greendark">51 - 60 anni</span>
          <span class="legend blue">oltre 61 anni</span>
        </div>

        </div>

      <!-- <pie v-if="benchlang === 'de'" :chart-data="{
      labels: ['Nicht-Betreuungsbereich: Mitarbeiter bis 30 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 31-40 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 41-50 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 51-60 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          data: [((klein[13].total / klein[13].arr.length)+(mittel[13].total / mittel[13].arr.length)+(gross[13].total / gross[13].arr.length))/3, ((klein[14].total / klein[14].arr.length)+(mittel[14].total / mittel[14].arr.length)+(gross[14].total / gross[14].arr.length))/3, ((klein[15].total / klein[15].arr.length)+(mittel[15].total / mittel[15].arr.length)+(gross[15].total / gross[15].arr.length))/3, ((klein[16].total / klein[16].arr.length)+(mittel[16].total / mittel[16].arr.length)+(gross[16].total / gross[16].arr.length))/3, ((klein[17].total / klein[17].arr.length)+(mittel[17].total / mittel[17].arr.length)+(gross[17].total / gross[17].arr.length))/3]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }}}, title: { display: false, text: 'Nicht-Betreuungsbereich: Mitarbeiter Altersstufen in %'
        }}"></pie>

        <pie v-if="benchlang === 'it'" :chart-data="{
      labels: ['Nicht-Betreuungsbereich: Mitarbeiter bis 30 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 31-40 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 41-50 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter 51-60 Jahre alt', 'Nicht-Betreuungsbereich: Mitarbeiter über 61 Jahre alt'],
      datasets: [
        {
          backgroundColor: [
            '#FFC002',
            '#FF9901',
            '#9BBB59',
            '#77933C',
            '#376092'
          ],
          data: [((klein[13].total / klein[13].arr.length)+(mittel[13].total / mittel[13].arr.length)+(gross[13].total / gross[13].arr.length))/3, ((klein[14].total / klein[14].arr.length)+(mittel[14].total / mittel[14].arr.length)+(gross[14].total / gross[14].arr.length))/3, ((klein[15].total / klein[15].arr.length)+(mittel[15].total / mittel[15].arr.length)+(gross[15].total / gross[15].arr.length))/3, ((klein[16].total / klein[16].arr.length)+(mittel[16].total / mittel[16].arr.length)+(gross[16].total / gross[16].arr.length))/3, ((klein[17].total / klein[17].arr.length)+(mittel[17].total / mittel[17].arr.length)+(gross[17].total / gross[17].arr.length))/3]
        }
      ]
    }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }}}, title: { display: false, text: 'Settore non-assistenziale: fasce d’età dei collaboratori in %'}}"></pie> -->

        <div v-html="content[6]"></div>

    <h2 v-if="benchlang === 'de'">5. PROZESSE</h2>
    <h2 v-if="benchlang === 'it'">5. PROCESSI</h2>

    <h5 v-if="benchlang === 'de'">Anzahl dokumentierte Schmerzeinschätzung (Mittelwerte)</h5>
    <h5 v-if="benchlang === 'it'">Numero delle valutazioni del dolore documentate (media)</h5>

    <div class="spacer sm"></div>

    <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [],
                    datasets: [
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[18].totval / klein[18].val.length)+(mittel[18].totval / mittel[18].val.length)+(gross[18].totval / gross[18].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: false, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl dokumentierte Schmerzeinschätzung (Mittelwerte)', padding: 40 }}"></stats>

    <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[18].totval / klein[18].val.length)+(mittel[18].totval / mittel[18].val.length)+(gross[18].totval / gross[18].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: false, maintainAspectRatio: true, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle valutazioni del dolore documentate (media)', padding: 40 }}"></stats>

      <div v-html="content[7]"></div>

      <h5 v-if="benchlang === 'de'">Anteil Bewohner mit Dekubiti (Mittelwerte in Prozent)</h5>
      <h5 v-if="benchlang === 'it'">Residenti con decubiti (media)</h5>

      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [['Anteil Bewohner mit Dekubiti','(Stichtag: 31.12.17)'],['Anteil Entstehungsort im Heim','(Stichtag 31.12.17)'],['Anteil Entstehungsort außerhalb des Heimes','(Stichtag 31.12.17)']],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[19].total / klein[19].arr.length, klein[20].total / klein[20].arr.length, klein[21].total / klein[21].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[19].total / mittel[19].arr.length, mittel[20].total / mittel[20].arr.length, mittel[21].total / mittel[21].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[19].total / gross[19].arr.length, gross[20].total / gross[20].arr.length, gross[21].total / gross[21].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[19].total / klein[19].arr.length)+(mittel[19].total / mittel[19].arr.length)+(gross[19].total / gross[19].arr.length))/3, ((klein[20].total / klein[20].arr.length)+(mittel[20].total / mittel[20].arr.length)+(gross[20].total / gross[20].arr.length))/3, ((klein[21].total / klein[21].arr.length)+(mittel[21].total / mittel[21].arr.length)+(gross[21].total / gross[21].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }, title: { display: false, text: 'Bewohner mit Dekubiti (Mittelwerte)', padding: 40
        }}"></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [['Quota percentuale e numero', 'dei residenti con decubiti (Senso 6)', 'Giorno di riferimento: 31.12.'], ['Quota percentuale e numero', 'dei residenti con decubiti con luogo', 'd’origine nella residenza', 'Giorno di riferimento: 31.12.'], ['Quota percentuale e numero', 'dei residenti con decubiti', 'con luogo d’origine al di fuori della residenza', 'Giorno di riferimento: 31.12.']],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[19].total / klein[19].arr.length, klein[20].total / klein[20].arr.length, klein[21].total / klein[21].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[19].total / mittel[19].arr.length, mittel[20].total / mittel[20].arr.length, mittel[21].total / mittel[21].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[19].total / gross[19].arr.length, gross[20].total / gross[20].arr.length, gross[21].total / gross[21].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[19].total / klein[19].arr.length)+(mittel[19].total / mittel[19].arr.length)+(gross[19].total / gross[19].arr.length))/3, ((klein[20].total / klein[20].arr.length)+(mittel[20].total / mittel[20].arr.length)+(gross[20].total / gross[20].arr.length))/3, ((klein[21].total / klein[21].arr.length)+(mittel[21].total / mittel[21].arr.length)+(gross[21].total / gross[21].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: { display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' } }, scales: { yAxes: [{ ticks: { beginAtZero:true } }] }, title: { display: false, text: 'Residenti con decubiti (media)', padding: 40
        }}"></stats>

        <div v-html="content[8]"></div>

        <h5 v-if="benchlang === 'de'">Anzahl Stürze mit Folge (Mittelwerte)</h5>
        <h5 v-if="benchlang === 'it'">Numero delle cadute con conseguenze (media)</h5>
        <div class="spacer sm"></div>

        <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[22].totval / klein[22].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[22].totval / mittel[22].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[22].totval / gross[22].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[22].totval / klein[22].val.length)+(mittel[22].totval / mittel[22].val.length)+(gross[22].totval / gross[22].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl Stürze mit Folge (Mittelwerte)', padding: 40 }}"></stats>

        <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[22].totval / klein[22].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[22].totval / mittel[22].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[22].totval / gross[22].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[22].totval / klein[22].val.length)+(mittel[22].totval / mittel[22].val.length)+(gross[22].totval / gross[22].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle cadute con conseguenze (media)', padding: 40 }}"></stats>

      <div v-html="content[9]"></div>

      <h5 v-if="benchlang === 'de'">Anzahl Stürze ohne Folge (Mittelwerte)</h5>
      <h5 v-if="benchlang === 'it'">Numero delle cadute senza conseguenze (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[23].totval / klein[23].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[23].totval / mittel[23].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[23].totval / gross[23].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[23].totval / klein[23].val.length)+(mittel[23].totval / mittel[23].val.length)+(gross[23].totval / gross[23].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl Stürze ohne Folge (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[23].totval / klein[23].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[23].totval / mittel[23].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[23].totval / gross[23].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[23].totval / klein[23].val.length)+(mittel[23].totval / mittel[23].val.length)+(gross[23].totval / gross[23].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle cadute senza conseguenze (media)', padding: 40 }}"></stats>

      <div v-html="content[10]"></div>

      <h5 v-if="benchlang === 'de'">Anteil Bewohner mit Einsatz freiheitseinschränkender Maßnahmen (Mittelwerte in Prozent zum Stichtag 31.12.{{value}})</h5>
      <h5 v-if="benchlang === 'it'">Residenti con degli interventi di contenzione fisica (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[24].total / klein[24].arr.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[24].total / mittel[24].arr.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[24].total / gross[24].arr.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[24].total / klein[24].arr.length)+(mittel[24].total / mittel[24].arr.length)+(gross[24].total / gross[24].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Bewohner mit Einsatz freiheitseinschränkender Maßnahmen (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[24].total / klein[24].arr.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[24].total / mittel[24].arr.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[24].total / gross[24].arr.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[24].total / klein[24].arr.length)+(mittel[24].total / mittel[24].arr.length)+(gross[24].total / gross[24].arr.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Residenti con degli interventi di contenzione fisica (media)', padding: 40 }}"></stats>

      <div v-html="content[11]"></div>

      <h5 v-if="benchlang === 'de'">Anzahl quittierter REHA-Leistungen (Mittelwerte)</h5>
      <h5 v-if="benchlang === 'it'">Numero delle prestazioni di riabilitazione validate/firmate (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[25].totval / klein[25].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[25].totval / mittel[25].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[25].totval / gross[25].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[25].totval / klein[25].val.length)+(mittel[25].totval / mittel[25].val.length)+(gross[25].totval / gross[25].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl quittierter REHA-Leistungen (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[25].totval / klein[25].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[25].totval / mittel[25].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[25].totval / gross[25].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[25].totval / klein[25].val.length)+(mittel[25].totval / mittel[25].val.length)+(gross[25].totval / gross[25].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle prestazioni di riabilitazione validate/firmate (media)', padding: 40 }}"></stats>

      <div v-html="content[12]"></div>

      <h5 v-if="benchlang === 'de'">Anzahl quittierter Leistungen der Tagesbetreuung (Mittelwerte)</h5>
      <h5 v-if="benchlang === 'it'">Numero delle prestazioni di assistenza giornaliera/animazione validate/firmate (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[26].totval / klein[26].val.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[26].totval / mittel[26].val.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[26].totval / gross[26].val.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[26].totval / klein[26].val.length)+(mittel[26].totval / mittel[26].val.length)+(gross[26].totval / gross[26].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Anzahl quittierter Leistungen der Tagesbetreuung (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[26].totval / klein[26].val.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[26].totval / mittel[26].val.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[26].totval / gross[26].val.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[26].totval / klein[26].val.length)+(mittel[26].totval / mittel[26].val.length)+(gross[26].totval / gross[26].val.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Numero delle prestazioni di assistenza giornaliera/animazione validate/firmate (media)', padding: 40 }}"></stats>

      <div v-html="content[13]"></div>

      <h5 v-if="benchlang === 'de'">Ausgaben für Lebensmittel und Getränke in Euro pro Heimbewohner pro Tag (Mittelwerte)</h5>
      <h5 v-if="benchlang === 'it'">Spese per alimentari e bibite in euro per residente al giorno (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[27].toteur / klein[27].eur.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[27].toteur / mittel[27].eur.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[27].toteur / gross[27].eur.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[27].toteur / klein[27].eur.length)+(mittel[27].toteur / mittel[27].eur.length)+(gross[27].toteur / gross[27].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Ausgaben für Lebensmittel und Getränke in € pro Heimbewohner pro Tag (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[27].toteur / klein[27].eur.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[27].toteur / mittel[27].eur.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[27].toteur / gross[27].eur.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[27].toteur / klein[27].eur.length)+(mittel[27].toteur / mittel[27].eur.length)+(gross[27].toteur / gross[27].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true }}] }, title: { display: false, text: 'Spese per alimentari e bibite in euro per residente al giorno (media)', padding: 40 }}"></stats>

      <div v-html="content[14]"></div>

       <h5 v-if="benchlang === 'de'">Personalkosten Küche für die Zubereitung von Lebensmitteln und den Abwasch in Euro pro Heimbewohner pro Tag (Mittelwerte)</h5>
      <h5 v-if="benchlang === 'it'">Costi per il personale di cucina per la preparazione degli alimenti e per la rigovernatura per residente in euro, al giorno (media)</h5>
      <div class="spacer sm"></div>

      <stats v-if="benchlang === 'de'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Kleine Strukturen',
                        backgroundColor: '#FFC002',
                        data: [klein[28].toteur / klein[28].eur.length]
                      },
                      {
                        label: 'Mittlere Strukturen',
                        backgroundColor: '#9BBB59',
                        data: [mittel[28].toteur / mittel[28].eur.length]
                      },
                      {
                        label: 'Grosse Strukturen',
                        backgroundColor: '#77933C',
                        data: [gross[28].toteur / gross[28].eur.length]
                      },
                      {
                        label: 'Durchschnitt',
                        backgroundColor: '#376092',
                        data: [((klein[28].toteur / klein[28].eur.length)+(mittel[28].toteur / mittel[28].eur.length)+(gross[28].toteur / gross[28].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, stepSize: 5 }}] }, title: { display: false, text: 'Personalkosten Küche für die Zubereitung von Lebensmitteln und den Abwasch in € pro Heimbewohner, pro Tag (Mittelwerte)', padding: 40 }}"></stats>

      <stats v-if="benchlang === 'it'" :chart-data="{
                    labels: [''],
                    datasets: [
                      {
                        label: 'Strutture piccole',
                        backgroundColor: '#FFC002',
                        data: [klein[28].toteur / klein[28].eur.length]
                      },
                      {
                        label: 'Strutture medie',
                        backgroundColor: '#9BBB59',
                        data: [mittel[28].toteur / mittel[28].eur.length]
                      },
                      {
                        label: 'Strutture grandi',
                        backgroundColor: '#77933C',
                        data: [gross[28].toteur / gross[28].eur.length]
                      },
                      {
                        label: 'Media',
                        backgroundColor: '#376092',
                        data: [((klein[28].toteur / klein[28].eur.length)+(mittel[28].toteur / mittel[28].eur.length)+(gross[28].toteur / gross[28].eur.length))/3]
                      }
                    ]
                  }" :options="{responsive: true, maintainAspectRatio: false, legend: {display: true, position: 'right'}, plugins: { datalabels: { color: '#000', font: { weight: 'bold' }, anchor: 'end', align: 'end' }}, scales: { yAxes: [{ ticks: { beginAtZero:true, stepSize: 5 }}] }, title: { display: false, text: 'Costi per il personale di cucina per la preparazione degli alimenti e per la rigovernatura per residente in euro, al giorno (media)', padding: 40 }}"></stats>

      <div v-html="content[15]"></div>

      <div class="spacer sm"></div>

      <!-- <p>{{klein[18]}}</p>
      <p>{{mittel[18]}} </p>
      <p>{{gross[18]}}</p>
      <p>{{overall[18]}} -</p> -->

    </div>

  </div>
</div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import Stats from '@/components/Stats'
  import Pie from '@/components/Pie'
  import {Circle4} from 'vue-loading-spinner'
  import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
  import { VueEditor } from 'vue2-editor'
  import * as docx from 'docx'
  import { saveAs } from 'file-saver'
  // import VueCharts from 'vue-chartjs'
  // import { Bar } from 'vue-chartjs'
  // import router from './../router'
  var host = 'https://bench.node.systems'
  // var host = 'http://localhost'
  export default {
    name: 'houses',
    // extends: Bar,
    props: ['cat', 'chartId'],
    data () {
      return {
        loading: false,
        // profile: JSON.parse(localStorage.profile),
        // tokwt: localStorage.jwt,
        houses: '',
        ratioquests: '',
        datacollection: null,
        content: {},
        cont: false,
        options: [{
          value: '2019',
          label: '2019'
        }, {
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }, {
          value: '2015',
          label: '2015'
        }, {
          value: '2014',
          label: '2014'
        }, {
          value: '2013',
          label: '2013'
        }],
        benchlangs: [{
          value: 'de',
          label: 'Deutsch'
        }, {
          value: 'it',
          label: 'Italienisch'
        }],
        value: this.$route.params.year,
        benchlang: this.$route.params.lang,
        content1: '<h1>content 1</h1>',
        title: [{
          de: 'Verhältnis Brutto- / Nettostunden Mitarbeiter (Mittelwerte)',
          it: 'Ore prestate dai collaboratori: lordo/netto (media)'
        }
        ],
        klein: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        mittel: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        gross: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        overall: {
          1: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          2: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          3: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          4: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          5: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          6: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          7: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          8: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          9: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          10: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          11: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          12: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          13: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          14: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          15: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          16: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          17: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          18: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          19: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          20: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          21: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          22: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          23: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          24: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          25: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          26: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          27: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0},
          28: {arr: [], total: 0, val: [], totval: 0, eur: [], toteur: 0}
        },
        state: {
          name: 'San Luis Potosi'
        }
      }
    },
    components: {
      Circle4,
      Navbar,
      // Bar,
      Stats,
      Pie,
      ChartJsPluginDataLabels,
      VueEditor,
      docx,
      saveAs
    },
    methods: {
      downcanvas (el) {
        console.log(el)
        // var canvas = $('#bar-chart').get(0)
        let canvas = document.getElementById('bar-chart').toDataURL('image/png')
        // var dataURL = canvas.toDataURL('image/jpeg')
        console.log(canvas)
        el.href = canvas
      },
      exportDocx () {
        let doc = new docx.Document()
        docx.Packer.toBlob(doc).then((blob) => {
          saveAs(blob, 'example.docx')
        })
      },
      edit: function (text) {
        console.log(text)
        this.content = text
        console.log(this.content)
        this.$modal.show('edit')
      },
      getoverall: function () {
        // this.overall.forEach((house, index) => {
        //   // console.log(house)
        // })
      },
      getHouses: function () {
        this.loading = true
        this.$http
          .get(host + ':44534/api/houses',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data.body)
            this.houses = data.body.houses
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      getContent: function (year) {
        this.loading = true
        this.$http
          .get(host + ':44534/api/benchmark/' + this.value,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            this.content = {}
            // console.log(data.body.benchmarks)
            console.log(this.benchlang)
            if (this.benchlang === 'de') {
              if (data.body.benchmarks.content === null || data.body.benchmarks.content === undefined) {
                this.content = {}
              } else {
                this.content = data.body.benchmarks.content
              }
            } else {
              if (data.body.benchmarks.contentit === null || data.body.benchmarks.contentit === undefined) {
                this.content = {}
              } else {
                this.content = data.body.benchmarks.contentit
              }
            }
            this.loading = false
            this.cont = true
          }, (error) => {
            console.log(error)
          })
      },
      saveContent: function () {
        console.log(this.content)
        this.loading = true
        if (this.benchlang === 'de') {
          this.$http
          .post(host + ':44534/api/benchmark/', {year: this.value, content: this.content},
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.jwt
              }
            }
            ).then((data) => {
              // this.ombrelli = data.body.ombrells
              console.log(data.body)
              // this.houses = data.body.houses
              this.loading = false
              this.$notify({
                group: 'foo',
                title: 'Bench saved successfully',
                type: 'success',
                duration: 500
              })
            }, (error) => {
              console.log(error)
            })
        } else {
          console.log(this.benchlang)
          this.$http
            .post(host + ':44534/api/benchmark/', {year: this.value, contentit: this.content},
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.jwt
              }
            }
            ).then((data) => {
              // this.ombrelli = data.body.ombrells
              console.log(data.body)
              // this.houses = data.body.houses
              this.loading = false
              this.$notify({
                group: 'foo',
                title: 'Bench saved successfully',
                type: 'success',
                duration: 500
              })
            }, (error) => {
              console.log(error)
            })
        }
      },
      getBench: function (house) {
        this.loading = true
        this.$http
          .get(host + ':44534/api/bench/' + house,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // console.log(data.body)
            this.ratioquests = data.body.ratioquests
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      getBenchVersion: function (version) {
        this.loading = true
        // this.$http
        //   .get(host + ':44534/api/bench/' + version,
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + localStorage.jwt
        //     }
        //   }
        //   ).then((data) => {
        //     // this.ombrelli = data.body.ombrells
        //     // console.log(data.body)
        //     this.ratioquests = data.body.ratioquests
        //     this.loading = false
        //   }, (error) => {
        //     console.log(error)
        //   })
      },
      getBenchAll: function (house) {
        this.loading = true
        this.getBench2('klein')
        this.getBench2('mittel')
        this.getBench2('gross')
        this.getContent()
      },
      getBench2: function (size) {
        this.loading = true
        console.log(this.value)
        // this.ratioquests = ''
        this.$http
          .get(host + ':44534/api/houses/' + size,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data.body.houses)
            data.body.houses.forEach((house, index) => {
              // console.log(house)
              this.$http
                .get(host + ':44534/api/bench/' + house._id + '/' + this.value,
                {
                  headers: {
                    'Authorization': 'Bearer ' + localStorage.jwt
                  }
                }
                ).then((data) => {
                  // this.ombrelli = data.body.ombrells
                  // console.log(data.body.ratioquests)
                  data.body.ratioquests.forEach((house, index) => {
                    // if (house.cat === 2 && house.ratioperc && house.ratioperc !== null) {
                    //   this.cat2.push(house.ratioperc)
                    //   this.cat2total += house.ratioperc
                    //   console.log(house.ratioperc)
                    // }
                    // if (house.cat === 3 && house.ratioperc && house.ratioperc !== null) {
                    //   this.cat3.push(house.ratioperc)
                    //   this.cat3total += house.ratioperc
                    //   console.log(house.ratioperc)
                    // }
                    // console.log(house.ratioeur)
                    if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                      this.overall[house.nr].arr.push(house.ratioperc)
                      this.overall[house.nr].total += house.ratioperc
                      // console.log(house.cat + '-' + this.overall[house.cat].total)
                      // console.log(house.ratioperc)
                    }
                    if (size === 'klein') {
                      if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                        this.klein[house.nr].arr.push(house.ratioperc)
                        this.klein[house.nr].total += house.ratioperc
                        // console.log(house.ratioperc)
                      }
                      if (house.ratioval !== undefined && Number.isInteger(house.ratioval)) {
                        this.klein[house.nr].val.push(house.ratioval)
                        this.klein[house.nr].totval += house.ratioval
                        // console.log(house.ratioperc)
                        // if (house.nr === 19) { console.log(house.ratioval) }
                      }
                      if (house.ratioeur !== undefined && typeof (house.ratioeur) === 'number') {
                        console.log(house.ratioeur)
                        this.klein[house.nr].eur.push(house.ratioeur)
                        this.klein[house.nr].toteur += house.ratioeur
                        // console.log(house.ratioperc)
                      }
                    }
                    if (size === 'mittel') {
                      if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                        this.mittel[house.nr].arr.push(house.ratioperc)
                        this.mittel[house.nr].total += house.ratioperc
                        // console.log(house.ratioperc)
                      }
                      if (house.ratioval !== undefined && Number.isInteger(house.ratioval)) {
                        this.mittel[house.nr].val.push(house.ratioval)
                        this.mittel[house.nr].totval += house.ratioval
                        // console.log(house.ratioperc)
                        // if (house.nr === 19) { console.log(house.ratioval) }
                      }
                      if (house.ratioeur !== undefined && typeof (house.ratioeur) === 'number') {
                        console.log(house.ratioeur)
                        this.mittel[house.nr].eur.push(house.ratioeur)
                        this.mittel[house.nr].toteur += house.ratioeur
                        // console.log(house.ratioperc)
                      }
                    }
                    if (size === 'gross') {
                      if (house.ratioperc !== undefined && typeof (house.ratioperc) === 'number') {
                        this.gross[house.nr].arr.push(house.ratioperc)
                        this.gross[house.nr].total += house.ratioperc
                        console.log(house.ratioperc)
                      }
                      if (house.ratioval !== undefined && Number.isInteger(house.ratioval)) {
                        this.gross[house.nr].val.push(house.ratioval)
                        this.gross[house.nr].totval += house.ratioval
                        // console.log(house.ratioperc)
                        // if (house.nr === 19) { console.log(house.ratioval) }
                      }
                      if (house.ratioeur !== undefined && typeof (house.ratioeur) === 'number') {
                        console.log(house.ratioeur)
                        this.gross[house.nr].eur.push(house.ratioeur)
                        this.gross[house.nr].toteur += house.ratioeur
                        // console.log(house.ratioperc)
                      }
                    }
                  })
                  this.loading = false
                }, (error) => {
                  console.log(error)
                })
            })
          }, (error) => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      // this.getBench2('klein')
      // this.getBench2('mittel')
      // this.getBench2('gross')
      // this.getHouses()
      // this.getContent('2017')
      this.getBenchAll()
    },
    // computed: {
    //   // a computed getter
    //   reversedMessage: function () {
    //     // `this` points to the vm instance
    //     // return this.message.split('').reverse().join('')
    //     return this.cat2overall = (this.cat2total / this.cat2.length)
    //   }
    // },
    mounted () {
    // Overwriting base render method with actual data.
      // this.renderChart({
      //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      //   datasets: [
      //     {
      //       label: 'GitHub Commits',
      //       backgroundColor: '#f87979',
      //       data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      //     },
      //     {
      //       label: 'GitHub Commits2',
      //       backgroundColor: '#FFD64E',
      //       data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      //     }
      //   ]
      // })
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/Print.vue